import { usePublicPricing, packageBase } from "@/lib/usePublicPricing";

const money = (n) => `$${(Number(n) || 0).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;

export const LivePricingHint = ({ pickup, ret }) => {
  const p = usePublicPricing();
  if (!pickup || !ret) return null;
  const d = Math.round((new Date(ret) - new Date(pickup)) / 86400000);
  if (!Number.isFinite(d) || d < 1) return null;

  if (d < 3) {
    return (
      <div data-testid="live-pricing-hint" className="rounded-lg border border-red-500/40 bg-red-500/[0.07] px-4 py-2.5 text-sm text-red-300">
        {d} Rental Day{d !== 1 ? "s" : ""} — below our minimum of 3 calendar days. Please extend your return date.
      </div>
    );
  }

  const base = packageBase(p, d);
  const weekly = d >= 7;
  const label = d === 3 ? "3 Rental Days — 3-Day Special" : `${d} Rental Days — Base Rental`;

  return (
    <div data-testid="live-pricing-hint" className={`rounded-lg border px-4 py-2.5 text-sm ${weekly ? "border-[#F2B705]/50 bg-[#F2B705]/[0.08]" : "border-white/15 bg-white/[0.04]"}`}>
      <div className="flex items-center justify-between gap-3">
        <span className="text-white/75 font-medium">{label}</span>
        <span data-testid="live-pricing-amount" className="font-display font-black text-gold-gradient text-lg">{money(base)}</span>
      </div>
      {weekly && (
        <div data-testid="weekly-special-badge" className="mt-1.5 text-[#F2B705] font-semibold text-[13px]">
          🎉 Weekly Special Applied — {money(p.weekly_special)}{d > 7 ? ` + ${d - 7} × ${money(p.additional_day_rate)}/day` : ""} (Best Value)
        </div>
      )}
      <div className="text-white/35 text-[11px] mt-1">Base rental only — coverage &amp; options are itemized separately. Rental days are counted by calendar date from pickup to return.</div>
    </div>
  );
};
